
import Phaser from 'phaser';
import Color from 'color';
import { fitTextToBox } from './PhaserUtils';

let gameOptions = {

	// slices configuration
	slices: [
		{
			degrees: 60,
			startColor: 0xff0000,
			endColor: 0xff8800,
			rings: 3,
			iconFrame: 1,
			iconScale: 0.7,
			sliceText: "0",
			text: "BANANA"
		},
		{
			degrees: 60,
			startColor: 0x00ff00,
			endColor: 0x004400,
			rings: 200,
			iconFrame: 0,
			iconScale: 0.2,
			sliceText: "1",
			text: "PEAR"
		},
		{
			degrees: 60,
			startColor: 0xff00ff,
			endColor: 0x0000ff,
			rings: 10,
			text: "BLUE TEXT, WHITE STROKE",
			sliceText: "BLUE 2",
			sliceTextStyle: {
				fontFamily: "Arial Black",
				fontSize: 36,
				color: "#000077"
			},
			sliceTextStroke: 8,
			sliceTextStrokeColor: "#ffffff"
		},
		{
			degrees: 60,
			startColor: 0x006666,
			endColor: 0x009999,
			rings: 200,
			iconFrame: 3,
			iconScale: 0.4,
			sliceText: "Ιs long 3",
			sliceTextStyle: {
				fontFamily: "Arial Black",
				fontSize: 36,
				color: "#000077",
				shadow: {
					offsetX: 5,
					offsetY: 2,
					color: '#fff',
					blur: 0,
					stroke: false,
					fill: true
				},
			},
			text: "STRAWBERRY"
		},
		{
			degrees: 60,
			startColor: 0x000000,
			endColor: 0xffff00,
			rings: 1,
			text: "POO :(",
			sliceText: "💩 4",
			sliceTextStyle: {
				fontFamily: "Arial Black",
				fontSize: 72
			},
		},
		{
			degrees: 60,
			startColor: 0x006666,
			endColor: 0x009999,
			rings: 200,
			iconFrame: 3,
			iconScale: 0.4,
			sliceText: "5",
			text: "STRAWBERRY"
		},
	],

	// wheel rotation duration range, in milliseconds
	rotationTimeRange: {
		min: 3000,
		max: 4500
	},

	// wheel rounds before it stops
	wheelRounds: {
		min: 4,
		max: 11
	},

	// degrees the wheel will rotate in the opposite direction before it stops
	backSpin: {
		min: 0,
		max: 0
	},

	// wheel radius, in pixels
	wheelRadius: 300,

	// color of stroke lines
	strokeColor: 0x000000,

	// width of stroke lines
	strokeWidth: 5,
	backgroundColor: 0x666666,
}

export class WheelScene extends Phaser.Scene {
	eventBus
	width
	height
	slices
	wheelRadius = 340
	strokeColor = 0x000000
	strokeWidth = 2
	fanSize = 0
	borderImage
	backgroundColor = 0x666666
	backgroundColors = []
	textColors = []
	shouldBreakSpinning = false

	constructor() {
		super('WheelScene');
	}
	init(data) {
		this.eventBus = data.eventBus
		this.width = data.width
		this.height = data.height
		this.wheelRadius = Math.min(this.width, this.height) / 2 - 60
		this.slices = data.slices
		this.borderImage = data.borderImage
		this.centerImage = data.centerImage
		this.centerImageSize = data.centerImageSize || 10
		this.pinImage = data.pinImage
		this.pinImageSize = data.pinImageSize || 100
		this.perpendicularText = data.perpendicularText
		this.backgroundColors = data.backgroundColors
		this.textColors = data.textColors
		this.borderStyle = data.borderStyle || "stroked"
		this.borderColor = data.borderColor || "#000000"
		this.borderWidth = data.borderWidth || 5
		this.spinDuration = data.spinDuration || 6
	}
	preload() {

		this.slices.forEach((slice, index) => {
			if (slice.image) {
				this.load.image("slice-image-" + index, slice.image.uri);
			}
		})

		this.load.image("border", this.borderImage || "/images/wheel/wheel-border.png" ); //possible placeholder "images/common/phaser-border.png"

		if (this.centerImage) {
			this.load.image("center", this.centerImage);
		}

		// this.load.setPath('images/wheel');
		// loading pin image
		if (this.pinImage) {
			this.load.image("pin", this.pinImage);
		}
		else {
			this.load.image("pin", "/images/wheel/pin-basic.png");
		}
	}

	// method to be executed once the scene has been created
	create() {

		// starting degrees
		let startDegrees = -90;

		if(this.borderStyle === "fanned"){
			this.fanSize = this.borderWidth
		}
		console.log("this.fanSize", this.fanSize)

		// making a graphic object without adding it to the game
		let graphics = this.make.graphics({
			x: 0,
			y: 0,
			add: false
		});

		// adding a container to group wheel and icons
		this.wheelContainer = this.add.container(this.width / 2, this.height / 2);

		// BORDER
		this.border = this.add.sprite(this.width / 2, this.height / 2, "border");
		this.border.displayWidth = this.width - 46;
		this.border.displayHeight = this.width - 46; //we want the border to always be square
		this.border.depth = 0

		// array which will contain all icons
		let iconArray = [];

		const sliceSize = 360 / this.slices.length

		this.slices = this.slices.map(slice => ({ ...slice, degrees: sliceSize, rings: 1 }))

		//DRAW BACKGROUND
		graphics.fillStyle("0x" + this.borderColor.slice(1), 1);
		graphics.fillCircle(this.wheelRadius + this.borderWidth, this.wheelRadius + this.borderWidth, this.wheelRadius)

		if(!this.borderImage){
			graphics.fillStyle("0x" + this.borderColor.slice(1), 1);
			graphics.fillCircle(this.wheelRadius + this.borderWidth, this.wheelRadius + this.borderWidth, this.wheelRadius);

			graphics.fillStyle("0xff0000", 1);
			graphics.fillCircle(this.wheelRadius + this.borderWidth, this.wheelRadius + this.borderWidth, 5);
		}

		//texture for the all the gifts
		const rt = this.make.renderTexture({width: this.width, height: this.height, add: false});

		// looping through each slice
		for (let i = 0; i < this.slices.length; i++) {

			//DRAW SLICE BACKGROUND - not needed now
			// graphics.fillStyle(this.backgroundColor, 1);
			// graphics.slice(this.wheelRadius + this.strokeWidth, this.wheelRadius + this.strokeWidth, this.wheelRadius, Phaser.Math.DegToRad(startDegrees), Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees), false);
			// graphics.fillPath();

			//DRAW SLICE
			if (this.slices[i].style.backgroundColor) {
				const bgColorHex = Color(this.slices[i].style.backgroundColor).hex().slice(1);
				graphics.fillStyle("0x" + bgColorHex, 1);
			}
			else {
				graphics.fillStyle("0x" + this.backgroundColors[this.slices.length % this.backgroundColors.length].slice(1), 1);
			}
			
			graphics.slice(
				this.wheelRadius + this.borderWidth,
				this.wheelRadius + this.borderWidth, this.wheelRadius,
				Phaser.Math.DegToRad(startDegrees + this.fanSize),
				Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees - this.fanSize), false
			);
			graphics.fillPath();

			// STROKE SLICE
			if(this.borderStyle === "stroked"){
				console.log("this.borderWidth, this.borderColor", this.borderWidth, this.borderColor)
				graphics.lineStyle(this.borderWidth, "0x" + this.borderColor.slice(1), 1);
				graphics.slice(this.wheelRadius + this.borderWidth, this.wheelRadius + this.borderWidth, this.wheelRadius, Phaser.Math.DegToRad(startDegrees), Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees), false);
				graphics.strokePath();
			}
			
			this.paokTextSizes = [
				44,
				28,
				30,
				34,
				44,
				28,
				28,
				28,
				44,
				28,
				44,
				28,
				44,
				28,
				28,
				24
			]

			// BOUNDS
			const arcLength = 2 * Math.PI * this.wheelRadius * this.slices[i].degrees / 360
			const chordLength = 2 * this.wheelRadius * Math.sin(this.slices[i].degrees * Math.PI / 360)
			const centerRadius = this.centerImageSize * this.wheelRadius / 100
			const boxHeight = (this.wheelRadius - this.centerImageSize * this.wheelRadius / 100 - 60)
			const boxWidth = this.centerImageSize * chordLength / 100 //the height near the edge of the center image

			// GIFT IMAGE
			if (this.slices[i].image != undefined) {
				
				const giftImage = this.add.image(0, 0, "slice-image-" + i)
				
				giftImage.scaleX = 1;
				giftImage.scaleY = 1;
				
				const giftImageAspect = giftImage.displayWidth / giftImage.displayHeight
				console.log("this.wheelRadius",this.wheelRadius)
				
				giftImage.displayHeight = boxWidth
				giftImage.displayWidth = giftImage.displayHeight * giftImageAspect

				const percentPos = 0.5;
				giftImage.x = (this.wheelRadius + centerRadius + giftImage.displayWidth/2 - 60 ) * percentPos * Math.cos(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2))
				giftImage.y = (this.wheelRadius + centerRadius + giftImage.displayWidth/2 - 60 ) * percentPos * Math.sin(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2))

				const giftRadius = Math.sqrt( Math.pow(giftImage.x, 2) + Math.pow(giftImage.y, 2) )
				const edgeRadius = giftRadius - giftImage.displayHeight/2
				const edgeChordLength = edgeRadius/this.wheelRadius*chordLength
				
				//limit width
				giftImage.displayWidth = edgeChordLength - 30
				giftImage.displayHeight = giftImage.displayWidth / giftImageAspect

				//if height out of limits, limit again according to height
				if(giftImage.displayHeight > 0.9 * boxHeight){
					giftImage.displayHeight = 0.9 * boxHeight
					giftImage.displayWidth = giftImage.displayHeight * giftImageAspect
				}
				
				//scale image
				giftImage.displayWidth = giftImage.displayWidth * (this.slices[i].image.sizeMultiplier || 1)
				giftImage.displayHeight = giftImage.displayWidth / giftImageAspect

				//apply offset
				if(this.slices[i].image.offsetY){
					const finalPos = 0.5 - (this.slices[i].image.offsetY/10 || 0);
					giftImage.x = (this.wheelRadius + centerRadius + giftImage.displayWidth/2 - 60 ) * finalPos * Math.cos(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2))
					giftImage.y = (this.wheelRadius + centerRadius + giftImage.displayWidth/2 - 60 ) * finalPos * Math.sin(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2))
				}

				// rotating the icon
				giftImage.angle = startDegrees + this.slices[i].degrees / 2 + 90;
				
				//mask for all the gifts
				const maskShape = this.make.graphics({ x: 54, y: 102, add: false });
				maskShape.fillStyle(0xffffff);
				
				maskShape.slice(
					this.wheelRadius + this.borderWidth,
					this.wheelRadius + this.borderWidth, this.wheelRadius,
					Phaser.Math.DegToRad(startDegrees + this.fanSize),
					Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees - this.fanSize), false
				);
				maskShape.fillPath();
				const mask = maskShape.createGeometryMask();
				giftImage.setMask(mask);
				
				rt.draw(giftImage, this.width/2 + giftImage.x, this.height/2 + giftImage.y);

				giftImage.destroy()

			}

			rt.saveTexture("gifts")
			const allGiftsImage = this.add.image(0, 0, "gifts");
		
			iconArray.push(allGiftsImage);

			// ADD TEXT
			if (this.slices[i].image === undefined && this.slices[i].option !== undefined) {
				// console.log("this.slices[i].option", this.slices[i].option)

				// the text
				let text = this.add.text(
					// this.wheelRadius * 0.65 * Math.cos(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2)), 
					// this.wheelRadius * 0.65 * Math.sin(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2)), 
					this.wheelRadius * 0.60 * Math.cos(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2)),
					this.wheelRadius * 0.60 * Math.sin(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2)),
					this.slices[i].option, {
					fontFamily: 'Poppins, "Segoe UI Black", "Roboto", "Helvetica Neue Condensed Black", sans-serif',
					fontSize: 100,//this.paokTextSizes[i],
					fontStyle: "bold",
					color: this.textColors[i],
					shadow: this.slices[i].style.textShadowColor ? {
						offsetX: 3,
						offsetY: 3,
						color: this.slices[i].style.textShadowColor,
						blur: 5,
						stroke: false,
						fill: true
					}: {},
					resolution: window.devicePixelRatio,
				},
				);

				const textWidth = this.centerImageSize < 50 ? 0.5 * chordLength: this.centerImageSize * chordLength / 100
				const textHeight = this.centerImageSize < 50 ? (this.wheelRadius - 0.5 * this.wheelRadius - 90): (this.wheelRadius - this.centerImageSize * this.wheelRadius/100 - 60) 

				let percentPos = 0.90 - (boxHeight - 40)/this.wheelRadius/2
				if (this.perpendicularText) {
					fitTextToBox(text, this.slices[i].option, textHeight + 40, textWidth)
					percentPos = 0.90 - (textHeight + 40)/this.wheelRadius/2
				}
				else {
					fitTextToBox(text, this.slices[i].option, boxHeight - 40, boxWidth)
				}
				text.x = this.wheelRadius * percentPos * Math.cos(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2))
				text.y = this.wheelRadius * percentPos * Math.sin(Phaser.Math.DegToRad(startDegrees + this.slices[i].degrees / 2))

				if (i === 0) {
					const textBounds = text.getBounds()
					graphics.lineStyle(2, 0xff0000, 1); // Red outline
					graphics.strokeRect(textBounds.x, textBounds.y, textBounds.width, textBounds.height);
				}

				// SHADOW
				// console.log("this.slices[i].backgroundColor).hex()", Color(this.slices[i].backgroundColor).hex(), ", text: ", this.textColors[i])
				// if(Color(this.slices[i].backgroundColor).hex() === "#000000" && (this.textColors[i] === "#fff" || this.textColors[i] === "#ffffff")){
				// 	text.preFX.addShadow(...[0, 0, 0.06, 0.75, 0xb99e71, 8, 0.8]);
				// }
				// if(Color(this.slices[i].backgroundColor).hex() === "#000000" && (this.textColors[i] === "#b99e6f")){
				// 	// console.log("hereeeeeeeeee")
				// 	text.preFX.addShadow(...[0, 0, 0.06, 0.75, 0x644e23, 8, 0.8]);
				// }
				// else{
				// 	// console.log("oh noooooo")
				// 	text.preFX.addShadow(...[0, 0, 0.06, 0.75, 0x000000, 8, 0.8]);
				// }

				//old style
				// text.preFX.setPadding(32); //extra texture space to render the effect (shadow)
				// if(this.slices[i].style.textShadowColor){
				// 	text.preFX.addShadow(...[0, 0, 0.06, 0.75, "0x" + this.slices[i].style.textShadowColor.slice(1), 8, 0.8]);
				// }


				// set text origin to its center
				text.setOrigin(0.5);

				// set text angle
				// text.angle = startDegrees + gameOptions.slices[i].degrees / 2 + 90;
				text.angle = startDegrees + this.slices[i].degrees / 2 + (this.perpendicularText ? 90 : 0);

				// stroke text, if required
				// if (this.slices[i].sliceTextStroke && this.slices[i].sliceTextStrokeColor) {
				// 	text.setStroke(this.slices[i].sliceTextStrokeColor, this.slices[i].sliceTextStroke);
				// }

				// add text to iconArray
				iconArray.push(text);
			}

			// updating degrees
			startDegrees += this.slices[i].degrees;

		}
		
		

		// generate a texture called "wheel" from graphics data
		graphics.generateTexture("wheel", (this.wheelRadius + this.borderWidth) * 2, (this.wheelRadius + this.borderWidth) * 2);

		// creating a sprite with wheel image as if it was a preloaded image
		let wheel = this.add.sprite(0, 0, "wheel");

		// adding the wheel to the container
		this.wheelContainer.add(wheel);

		// adding all iconArray items to the container
		this.wheelContainer.add(iconArray);

		// PIN
		this.pin = this.add.sprite(this.width / 2, 0, "pin");
		const pinAspect = this.pin.displayWidth/this.pin.displayHeight;
		this.pin.displayWidth = this.wheelRadius * 0.20*this.pinImageSize/100;
		this.pin.displayHeight = this.pin.displayWidth/pinAspect;
		this.pin.y = this.pin.displayHeight/2;
		console.log("please this.pin.displayWidth, this.pin.displayWidth", this.pin.displayWidth, this.pin.displayWidth)

		// // Define colors
		// let pinColor = 0xff0000; // Red color for the pin

		// // Draw the triangular pin
		// graphics.fillStyle(pinColor, 1);
		// graphics.beginPath();
		// graphics.moveTo(200, 50);   // Top point
		// graphics.lineTo(180, 90);   // Bottom left
		// graphics.lineTo(220, 90);   // Bottom right
		// graphics.closePath();
		// graphics.fillPath();

		// CENTER IMAGE in the middle of the canvas
		if (this.centerImage) {
			this.centerSprite = this.add.sprite(this.width / 2, this.height / 2, "center");
			const aspect = this.centerSprite.displayWidth / this.centerSprite.displayHeight;
			this.centerSprite.displayWidth = 2 * this.wheelRadius * this.centerImageSize / 100;
			this.centerSprite.displayHeight = this.centerSprite.displayWidth / aspect;
		}
		else {
			const centerGraphics = this.add.graphics();
			const centerCircleRadius = this.wheelRadius * this.centerImageSize / 100
			// centerGraphics.lineStyle(this.borderWidth, "0x" + this.borderColor.slice(1), 1);
			// centerGraphics.strokeCircle(this.width/2, this.height / 2, centerCircleRadius)
			centerGraphics.fillStyle("0x" + this.borderColor.slice(1), 1);
			centerGraphics.fillCircle(this.width/2, this.height / 2, centerCircleRadius)
		}

		// // adding the text field
		// this.prizeText = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT - 20, "Spin the wheel", {
		// 	font: "bold 32px Arial",
		// 	align: "center",
		// 	color: "white"
		// });

		// // center the text
		// this.prizeText.setOrigin(0.5);

		// the game has just started = we can spin the wheel
		this.canSpin = true;

		// waiting for your input, then calling "spinWheel" function
		// this.input.on("pointerdown", this.spinWheel, this);
		this.eventBus.emit('create')
	}

	// function to spin the wheel
	execute(data) {

		// can we spin the wheel?
		if (this.canSpin) {

			// resetting text field
			// this.prizeText.setText("");

			// the wheel will spin round for some times. This is just coreography
			// let rounds = Phaser.Math.Between(gameOptions.wheelRounds.min, gameOptions.wheelRounds.max);

			// then will rotate by a random number from 0 to 360 degrees. This is the actual spin
			let degrees = Phaser.Math.Between(0, 360);

			// then will rotate back by a random amount of degrees
			// let backDegrees = Phaser.Math.Between(gameOptions.backSpin.min, gameOptions.backSpin.max);

			const prize = data.prizeNumber; // = sliceIndex

			// Attention!: this means the user lost but there is no visible losing slice
			if(prize > this.slices.length - 1){
				this.shouldBreakSpinning = true;
				setTimeout(() => this.eventBus.emit('spin-end'), this.spinDuration*1000/2)
			}

			// before the wheel ends spinning, we already know the prize
			let prizeDegree = -prize * this.slices[0].degrees - Math.floor(Math.random() * (this.slices[0].degrees - 2 * this.borderWidth) + this.borderWidth) //- 60 / 2 ;

			// looping through slices
			// for (let i = gameOptions.slices.length - 1; i >= 0; i--) {

			// 	// adding current slice angle to prizeDegree
			// 	prizeDegree += gameOptions.slices[i].degrees;

			// 	// if it's greater than the random angle...
			// 	if (prizeDegree > degrees - backDegrees) {

			// 		// we found the prize
			// 		var prize = i;
			// 		break;
			// 	}
			// }

			// now the wheel cannot spin because it's already spinning
			this.canSpin = false;
			// animation tweeen for the spin: duration 3s, will rotate by (360 * rounds + degrees) degrees
			// the quadratic easing will simulate friction
			this.tweens.chain({
				// adding the wheel container to tween targets
				targets: [this.wheelContainer],
				tweens: [
					{
						angle: 360 * this.spinDuration + prizeDegree, //old:  360 * rounds + degrees
						ease: 'Cubic.easeInOut', // 'Cubic', 'Elastic', 'Bounce', 'Back'
						duration: this.spinDuration*1000, //Phaser.Math.Between(gameOptions.rotationTimeRange.min, gameOptions.rotationTimeRange.max),
						repeat: 0, // -1: infinity
						yoyo: false
					},
					// {
					// 	angle: 360*5 + prizeDegree, //old:  360 * rounds + degrees
					// 	ease: 'Expo.easeOut', // 'Cubic', 'Elastic', 'Bounce', 'Back'
					// 	duration: 2000,
					// 	repeat: 0, // -1: infinity
					// 	yoyo: false
					// },
				],
				delay: 0,
				completeDelay: 0,
				loop: 0,  // repeat: 0,
				repeatDelay: 0,
				paused: false,
				persist: true,
				callbackScope: this,
				onComplete: function (tween) {
					if(!this.shouldBreakSpinning){
						setTimeout(() => this.eventBus.emit('spin-end'), 1000)
					}
				},
			});
		}
	}

	changeScene() {
		// this.scene.start('GameOver');
	}
}

// onComplete: function (tween) {
// 	// another tween to rotate a bit in the opposite direction
// 	this.tweens.add({
// 		targets: [this.wheelContainer],
// 		angle: this.wheelContainer.angle - backDegrees,
// 		duration: Phaser.Math.Between(gameOptions.rotationTimeRange.min, gameOptions.rotationTimeRange.max) / 2,
// 		ease: "Cubic.easeIn",
// 		callbackScope: this,
// 		onComplete: function (tween) {

// 			// displaying prize text
// 			this.prizeText.setText(gameOptions.slices[prize].text);

// 			// player can spin again
// 			this.canSpin = true;
// 		}
// 	})
// }